
























































import { computed, defineComponent, PropType } from '@vue/composition-api';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import { EventBannerReportData } from '@front-app/services/EventsApi/EventDataModel';
import { sortAlphabeticalDesc } from '@front-app/util/sort';
import { sum } from '@front-app/util/math';
import { sortEventBannerReportHeaders } from '../util/sort';
import { toTable, getColumnTitle } from '../util/table';
import { EventDataColumn } from '../Model';

export default defineComponent({
	components: { SimpleCard },
	props: {
		inputData: {
			type: Array as PropType<EventBannerReportData[]>,
			required: true,
		},
	},
	setup(props) {
		const tabulatedData = computed(() => toTable(props.inputData));
		const sortedRowKeys = computed(() => Object.keys(tabulatedData.value.rows)
			.sort(sortAlphabeticalDesc));
		const sortedColumns = computed(() => tabulatedData.value
			.columns
			.sort(sortEventBannerReportHeaders));
		const getCount = (dateKey: string, columnKey: string) => tabulatedData.value
			.rows[dateKey]
			.cells[columnKey] || 0;
		const sumRow = (dateKey: string) => sortedColumns.value
			.map(({ columnId }) => getCount(dateKey, columnId))
			.reduce(sum, 0);

		const isGroupColumn = (col: EventDataColumn): boolean => Boolean(col.columnData.groupId);
		const isUserColumn = (col: EventDataColumn): boolean => !col.columnData.groupId;

		return {
			getCount,
			getColumnTitle,
			sumRow,
			tabulatedData,
			sortedRowKeys,
			sortedColumns,
			// Column formatting helpers
			isGroupColumn,
			isUserColumn,
		};
	},
});
